import {TrDialog} from "../../Models/tr-dialog";
import {ExpenseType} from "../../Data/Data";
import {ExpenseTypeDialog, getExpenseTypeLabel} from "../../Models/expense-type-dialog";

const ExpenseTypeView = require('./expense-type-dialog.html');

interface IScope extends ng.IScope {
    dialog: TrDialog;
    entries: ExpenseType[];
    callback: (timeEntry: ExpenseType) => void;
    select: (entry: ExpenseType) => void;
    getTypeName: (entry: ExpenseType) => string;
}

export const ExpenseTypeDialogDirective = [
    () => {
        return {
            restrict: 'E',
            scope: {instance: '='},
            templateUrl: ExpenseTypeView,
            link: (scope: IScope, element, attrs) => {
                scope.dialog = new TrDialog();

                scope.$watch('instance', (value: ExpenseTypeDialog) => {
                    value.open = (callback: (value: ExpenseType) => void) => {
                        scope.callback = callback;
                        scope.dialog.open();
                        scope.entries = [ExpenseType.Default, ExpenseType.CarKilometers, ExpenseType.MotorCycleKilometers];
                    };
                });

                scope.getTypeName = (entry: ExpenseType) => {
                    return getExpenseTypeLabel(entry);
                }

                scope.select = (entry: ExpenseType) => {
                    scope.callback(entry);
                    scope.dialog.close();
                };
            },
        };
    }
]
